export const ReflectionEmojiTypeEnum = {
    VerySad: 1,
    Sad: 2,
    UnHappy: 3,
    Happy: 4,
    VaryHappy: 5
}